module.exports = __webpack_public_path__ + "static/img/5.5596030.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/version/02/5.png
// module id = AXRP
// module chunks = 1